/**
 * **Das Daily** – gemeinsame Begriffe für Server und Oberfläche
 * ([Z-18](../../../docs/phasen/zusatz-18-daily.md)).
 */

/**
 * **Woher ein Protokolleintrag kommt.**
 *
 * `markierung` entsteht am ⚑ einer Aufgaben- oder Personenzeile – sie steht oben bei der Sache.
 * `notiz` entsteht im Schreibfeld und steht im Gesprächsfaden darunter.
 *
 * Mehr trennt sie nicht: Beide sind ein Satz im Protokoll mit optionalem Bezug, und beide werden
 * zum Kommentar an der Aufgabe, wenn sie eine nennen.
 */
export const DAILY_EINTRAG_ARTEN = ['markierung', 'notiz'] as const
export type DailyEintragArt = (typeof DAILY_EINTRAG_ARTEN)[number]

/**
 * **Wie viele Tage zurück „Erledigt" reicht** – Nils: *„letzten 7 Tage"*.
 *
 * Sieben und nicht fünf: Ein Daily am Montag soll auch zeigen, was am Freitag noch fertig wurde.
 */
export const DAILY_ERLEDIGT_TAGE = 7

/** **Wie viele Zeilen der Vorlauf zeigt** – Nils: *„die nächsten Aufgaben aus dem Vorlauf (7 Stück)"*. */
export const DAILY_VORLAUF_ZEILEN = 7

/**
 * **Der Vorspann, mit dem ein Protokolleintrag an der Aufgabe erscheint.**
 *
 * Nils: *„die notizen sollen da als kommentar (vom daily 16.09.26: ...) rein gehen."*
 *
 * Er steht hier und nicht im Router, weil ihn zwei Seiten kennen müssen: Der Server schreibt ihn,
 * und die Oberfläche zeigt vor dem Beenden, was gleich an der Aufgabe stehen wird. Zwei
 * Schreibweisen desselben Satzes wären genau die Art Unterschied, die erst auffällt, wenn jemand
 * danach sucht.
 */
export function dailyKommentarVorspann(datum: string): string {
  return `Aus dem Daily vom ${datumLesbar(datum)}: `
}

/**
 * `JJJJ-MM-TT` → `TT.MM.JJJJ`. Ohne Zeitzone, weil das Datum hier ein **Name** ist und kein
 * Zeitpunkt – siehe die Spalte `daily.datum`.
 */
export function datumLesbar(datum: string): string {
  const [jahr, monat, tag] = datum.split('-')
  return jahr && monat && tag ? `${tag}.${monat}.${jahr}` : datum
}
